module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showGetrankeStand = true) && (_vm.neuZahlung = true) && (_vm.zahlung = _vm.neueZahlung)
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Zählen")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "disabled": ""
          }
        }, on), [_c('v-icon', [_vm._v("save_alt")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Exportieren")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "disabled": ""
          }
        }, on), [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Löschen")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Suchen",
      "single-line": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "center-active": "",
      "centered": ""
    },
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, _vm._l((_vm.getrankestande), function(getrankestand, jahr) {
    return _c('v-tab', {
      key: jahr
    }, [_vm._v(_vm._s(jahr))])
  }), 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, _vm._l((_vm.getrankestande), function(getrankestand, jahr) {
    return _c('v-tab-item', {
      key: jahr
    }, [_c('v-data-table', {
      attrs: {
        "height": "calc(100vh - 240px)",
        "dense": "",
        "headers": _vm.headers,
        "items": getrankestand,
        "search": _vm.search,
        "fixed-header": "",
        "hide-default-footer": "",
        "items-per-page": -1,
        "hide-default-header": _vm.hideHeader,
        "no-data-text": "Keine Zählungen vorhanden"
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(ref) {
          var item = ref.item;

          return [_c('tr', {
            staticClass: "hidden-sm-and-up"
          }, [_c('th', [_vm._v("Datum")]), _vm._v(" "), _c('th', [_vm._v("Betrag")]), _vm._v(" "), _c('th')])]
        }
      }, {
        key: "item",
        fn: function(ref) {
          var item = ref.item;

          return [_c('tr', {
            on: {
              "dblclick": function($event) {
                (_vm.zahlung = item) && (_vm.showGetrankeStand = true) && (_vm.neueZahlung = false)
              }
            }
          }, [_c('td', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY")))]), _vm._v(" "), (item.zahler) ? _c('td', {
            staticClass: "hidden-xs-only"
          }, [_vm._v(_vm._s(_vm.$filters.user(item.zahler, _vm.bbrbbr)))]) : _c('td', {
            staticClass: "hidden-xs-only"
          }), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.volumen.toFixed(1)) + " l")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.gesamt)))]), _vm._v(" "), _c('td', {
            staticClass: "pl-0 pr-2",
            attrs: {
              "width": "20px"
            }
          }, [_c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                (_vm.zahlung = item) &&
                (_vm.positionen = item.positionen) &&
                (_vm.positionenPfand = item.positionenPfand) &&
                (_vm.showGetrankeStand = true) &&
                (_vm.neueZahlung = false)
              }
            }
          }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)])]
        }
      }], null, true)
    })], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showGetrankeStand),
      callback: function($$v) {
        _vm.showGetrankeStand = $$v
      },
      expression: "showGetrankeStand"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "primary white--text"
  }, [(_vm.neueZahlung) ? _c('div', [_vm._v("Neue Getränkezählung erstellen")]) : _c('div', [_vm._v("Zählung vom " + _vm._s(_vm.$filters.date(_vm.zahlung.datum, "DD.MM.YYYY")))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showGetrankeStand = false
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateDate(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-left": 65,
      "nudge-bottom": 10,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": ""
          }
        }, on), [_c('span', {
          staticClass: "title"
        }, [_vm._v(_vm._s(_vm.$filters.date(_vm.zahlung.datum, "DD.MM.YYYY")))])])]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de"
    },
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.zahlung.datum),
      callback: function($$v) {
        _vm.$set(_vm.zahlung, "datum", $$v)
      },
      expression: "zahlung.datum"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateDate(1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2",
      "offset-md": "2"
    }
  }, [_c('v-card', {
    staticClass: "text-center py-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v("Summe")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summe)))])])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('v-card', {
    staticClass: "text-center py-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v("Pfand")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summePfand)))])])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('v-card', {
    staticClass: "text-center py-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v("MwSt.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summeMwst)))])])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4",
      "md": "2"
    }
  }, [_c('v-card', {
    staticClass: "text-center py-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v("Gesamt")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summeGesamt)))])])], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("\n                Getränke\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        (_vm.showSpeedInsert = true) && _vm.calcTabelleGetranke()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2"
  }, [_vm._v("speed")]), _vm._v("Speedeingabe")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "Getränk",
      "items": _vm.getranke
    },
    model: {
      value: (_vm.getrank),
      callback: function($$v) {
        _vm.getrank = $$v
      },
      expression: "getrank"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-outer-icon": "plus_one",
      "prepend-icon": "exposure_neg_1",
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "type": "number",
      "min": "0",
      "value": _vm.anzahlGetrank,
      "label": "Anzahl"
    },
    on: {
      "click:append-outer": function($event) {
        _vm.anzahlGetrank++
      },
      "click:prepend": function($event) {
        _vm.anzahlGetrank > 0 ? _vm.anzahlGetrank-- : ''
      }
    },
    model: {
      value: (_vm.anzahlGetrank),
      callback: function($$v) {
        _vm.anzahlGetrank = $$v
      },
      expression: "anzahlGetrank"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    },
    on: {
      "click": _vm.addGetrank
    }
  }, [_c('v-icon', [_vm._v("playlist_add")])], 1)], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(100vh - 400px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', [_vm._v("Anzahl")]), _vm._v(" "), _c('th', [_vm._v("Netto")]), _vm._v(" "), _c('th', [_vm._v("Summe")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.zahlung.positionen), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.netto)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.summe)))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.delGetrank(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-1"
  }, [_vm._v("Pfand")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "Getränk",
      "items": _vm.getranke
    },
    model: {
      value: (_vm.pfand),
      callback: function($$v) {
        _vm.pfand = $$v
      },
      expression: "pfand"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-outer-icon": "plus_one",
      "prepend-icon": "exposure_neg_1",
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "type": "number",
      "min": "0",
      "value": _vm.anzahlPfand,
      "label": "Anzahl"
    },
    on: {
      "click:append-outer": function($event) {
        _vm.anzahlPfand++
      },
      "click:prepend": function($event) {
        _vm.anzahlPfand > 0 ? _vm.anzahlPfand-- : ''
      }
    },
    model: {
      value: (_vm.anzahlPfand),
      callback: function($$v) {
        _vm.anzahlPfand = $$v
      },
      expression: "anzahlPfand"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    },
    on: {
      "click": _vm.addPfand
    }
  }, [_c('v-icon', [_vm._v("playlist_add")])], 1)], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(100vh - 400px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', [_vm._v("Anzahl")]), _vm._v(" "), _c('th', [_vm._v("Pfand")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.zahlung.positionenPfand), function(item) {
    return _c('tr', {
      key: item.name
    }, [_c('td', [_vm._v(_vm._s(item.bezeichnung))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.anzahl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.pfand)))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.delPfand(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(!_vm.neuZahlung) ? _c('v-btn', _vm._g({
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteZahlung = true
      }
    }
  }, _vm.on), [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showGetrankeStand = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), (_vm.neueZahlung) ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveZahlung()
      }
    }
  }, [_vm._v("Speichern")]) : _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.updateZahlung()
      }
    }
  }, [_vm._v("Update")])], 1)], 1)], 1), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteZahlung,
      "title": "Zählung löschen",
      "message": "Willst du diese Zählung wirklich löschen?",
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteZahlung = $event
      },
      "closeTrue": function($event) {
        return _vm.deleteZahlung()
      },
      "closeFalse": function($event) {
        _vm.showDeleteZahlung = false
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "90%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showSpeedInsert),
      callback: function($$v) {
        _vm.showSpeedInsert = $$v
      },
      expression: "showSpeedInsert"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Getränke hinzufügen\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showSpeedInsert = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('draggable', {
    attrs: {
      "group": "myGroup"
    },
    on: {
      "change": _vm.savereihenfolge
    },
    model: {
      value: (_vm.tabelleGetranke[0]),
      callback: function($$v) {
        _vm.$set(_vm.tabelleGetranke, 0, $$v)
      },
      expression: "tabelleGetranke[0]"
    }
  }, _vm._l((_vm.tabelleGetranke[0]), function(item, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "py-0 px-1"
    }, [_c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      staticClass: "grey--text"
    }, [_vm._v("drag_indicator")])], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "my-0"
    }, [_c('v-list-item-title', [_vm._v(_vm._s(item.bezeichnung))])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-responsive', {
      staticClass: "pt-1 mr-4",
      attrs: {
        "max-width": "50"
      }
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "label": "0",
        "single-line": "",
        "outlined": "",
        "rules": [_vm.rules.number]
      },
      model: {
        value: (item.anzahl),
        callback: function($$v) {
          _vm.$set(item, "anzahl", $$v)
        },
        expression: "item.anzahl"
      }
    })], 1)], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('draggable', {
    attrs: {
      "group": "myGroup"
    },
    on: {
      "change": _vm.savereihenfolge
    },
    model: {
      value: (_vm.tabelleGetranke[1]),
      callback: function($$v) {
        _vm.$set(_vm.tabelleGetranke, 1, $$v)
      },
      expression: "tabelleGetranke[1]"
    }
  }, _vm._l((_vm.tabelleGetranke[1]), function(item, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "py-0 px-1"
    }, [_c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      staticClass: "grey--text"
    }, [_vm._v("drag_indicator")])], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "my-0"
    }, [_c('v-list-item-title', [_vm._v(_vm._s(item.bezeichnung))])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-responsive', {
      staticClass: "pt-1 mr-4",
      attrs: {
        "max-width": "50"
      }
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "label": "0",
        "single-line": "",
        "outlined": "",
        "rules": [_vm.rules.number]
      },
      model: {
        value: (item.anzahl),
        callback: function($$v) {
          _vm.$set(item, "anzahl", $$v)
        },
        expression: "item.anzahl"
      }
    })], 1)], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('draggable', {
    attrs: {
      "group": "myGroup"
    },
    on: {
      "change": _vm.savereihenfolge
    },
    model: {
      value: (_vm.tabelleGetranke[2]),
      callback: function($$v) {
        _vm.$set(_vm.tabelleGetranke, 2, $$v)
      },
      expression: "tabelleGetranke[2]"
    }
  }, _vm._l((_vm.tabelleGetranke[2]), function(item, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "py-0 px-1"
    }, [_c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      staticClass: "grey--text"
    }, [_vm._v("drag_indicator")])], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "my-0"
    }, [_c('v-list-item-title', [_vm._v(_vm._s(item.bezeichnung))])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-responsive', {
      staticClass: "pt-1 mr-4",
      attrs: {
        "max-width": "50"
      }
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "label": "0",
        "single-line": "",
        "outlined": "",
        "rules": [_vm.rules.number]
      },
      model: {
        value: (item.anzahl),
        callback: function($$v) {
          _vm.$set(item, "anzahl", $$v)
        },
        expression: "item.anzahl"
      }
    })], 1)], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('draggable', {
    attrs: {
      "group": "myGroup"
    },
    on: {
      "change": _vm.savereihenfolge
    },
    model: {
      value: (_vm.tabelleGetranke[3]),
      callback: function($$v) {
        _vm.$set(_vm.tabelleGetranke, 3, $$v)
      },
      expression: "tabelleGetranke[3]"
    }
  }, _vm._l((_vm.tabelleGetranke[3]), function(item, index) {
    return _c('v-list-item', {
      key: index,
      staticClass: "py-0 px-1"
    }, [_c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      staticClass: "grey--text"
    }, [_vm._v("drag_indicator")])], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "my-0"
    }, [_c('v-list-item-title', [_vm._v(_vm._s(item.bezeichnung))])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-responsive', {
      staticClass: "pt-1 mr-4",
      attrs: {
        "max-width": "50"
      }
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "label": "0",
        "single-line": "",
        "outlined": "",
        "rules": [_vm.rules.number]
      },
      model: {
        value: (item.anzahl),
        callback: function($$v) {
          _vm.$set(item, "anzahl", $$v)
        },
        expression: "item.anzahl"
      }
    })], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showSpeedInsert = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.insertGertranke()
      }
    }
  }, [_vm._v("speichern")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e532a29e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/bierwartGetrankeZahlen.vue
// module id = 817
// module chunks = 15